import * as React from "react";
import styled from "styled-components";
import Gutters from "src/components/gutters";
import inIframe from "src/components/in-iframe";
import { Helmet } from "react-helmet";
import AppProviders from "./components/providers";
import GlobalStyle from "./components/global-style";
import Footer from "./components/footer";
import Flex from "./components/flex";
import ErrorBoundary from "./scenes/errors/error-boundary";
import Routes from "./scenes/routes";
import DelegatedAccessBanner from "./components/delegated-access-banner";
import NotificationsSnackbar from "./components/notification-snackbar";

const BodyContainer = styled(Flex).attrs(() => ({
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    overflowX: "hidden",
}))`
    width: 100%;
    position: relative;
    z-index: 2;
    background: ${({ theme }) => theme.palette.background.default};
    ${({ theme }) => theme.breakpoints.down("sm")} {
        padding: ${({ theme }) => theme.spacing(0)};
        margin-top: ${({ theme }) => theme.spacing(2)};
    }
`;

const App: React.FC = () => {
    return (
        <AppProviders>
            {({ handleSetDark }) => (
                <>
                    {process.env.ENVIRONMENT_NAME === "prod" ? (
                        <Helmet>
                            <script
                                async
                                src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GTAG_ID}`}
                            />
                            <script>
                                {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}; gtag('js', new Date()); gtag('config', "${process.env.GTAG_ID}");`}
                            </script>
                        </Helmet>
                    ) : (
                        <Helmet>
                            <title>Adadot</title>
                        </Helmet>
                    )}

                    <GlobalStyle />
                    <BodyContainer>
                        <DelegatedAccessBanner />
                        <div id="demo-portal-id" style={{ width: "100%" }} />
                        <Gutters pt={4} style={{ alignItems: "center" }}>
                            <ErrorBoundary>
                                <Routes handleSetDark={handleSetDark} />
                            </ErrorBoundary>
                        </Gutters>
                    </BodyContainer>
                    <NotificationsSnackbar />
                    {!inIframe() && <Footer />}
                </>
            )}
        </AppProviders>
    );
};

export default App;
